import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

type ItemProps = {
  isDisabled?: boolean;
  isSelected?: boolean;
};

export const Item = styled(Flex).attrs({
  align: 'center',
  width: '100%',
}) <ItemProps>`
  overflow: hidden;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
  min-height: 120px;

  &:hover {
    border: 1px solid ${props => props.theme.colors.primary};
    box-shadow: 0px 2px 7px 0px #00000026;
  }

  ${props => props.isSelected && `
    border: 1px solid ${props.theme.colors.primary};
    box-shadow: 0px 2px 7px 0px #00000026;

    .ItemTitle {
      color: ${props.theme.colors.primary};
    }
  `}

  ${props => props.isDisabled && `
    color: #b3b3b3;
    cursor: not-allowed;
    border: 1px solid #b3b3b3;
    box-shadow: 0px 2px 7px 0px #00000026;

    .ItemTitle {
      color: #b3b3b3;
    }
  `}
`;

export const ItemCircle = styled.div<ItemProps>`
  width: 25px;
  height: 25px;
  border: 1px solid #B6B6B6;
  position: relative;
  border-radius: 50%;
  box-sizing: border-box;
  flex-shrink: 0;
  margin-left: 20px;

  ${props => props.isSelected && `
    border: 1px solid ${props.theme.colors.primary};

    &:after {
      display: block;
      background: ${props.theme.colors.primary};
    }
  `}

  &:after {
    content: '';
    width: 17px;
    height: 17px;
    position: absolute;
    left: 3px;
    top: 3px;
    border-radius: 50%;
    display: ${props => props.isSelected ? 'block' : 'none'};
    background: ${props => props.theme.colors.primary};
  }

  ${props => props.isDisabled && `
    border: 1px solid #b3b3b3;

    &:after {
      background: #f9f9f9;
    }
  `}
`;

export const ItemTitle = styled.span`
  color: #757575;
  font-size: 1.6em;
  font-weight: 600;
  line-height: 44px;

  span {
    color: #757575;
    font-size: 0.7em;
    font-weight: 400;
    margin-left: 20px;
  }

  svg {
    position: relative;
    top: 5px;
    left: 10px;
  }
`;
